import { render, staticRenderFns } from "./AxHeading.vue?vue&type=template&id=58e8db42&scoped=true&"
import script from "./AxHeading.vue?vue&type=script&lang=ts&"
export * from "./AxHeading.vue?vue&type=script&lang=ts&"
import style0 from "./AxHeading.vue?vue&type=style&index=0&id=58e8db42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8db42",
  null
  
)

export default component.exports